import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Navigations } from "./AppRoutes";
import { Helmet } from "react-helmet";

const HYMNS_COVER_IMAGE =
  "https://ik.imagekit.io/4apzi8lz0/egarizim/chant-esperance-api.jpg";
const DEFAULT_COVER_IMAGE =
  "https://ik.imagekit.io/4apzi8lz0/egarizim/cover.png?updatedAt=1788639821589";

const AppSeoProvider = () => {
  const location = useLocation();
  const [url, setUrl] = useState<string>(
    typeof window !== "undefined" ? window.location.href : "",
  );
  const [title, setTitle] = useState<string>("");

  useEffect(() => {
    const currentUrl =
      typeof window !== "undefined" ? window.location.href : "";
    const pathName = location.pathname;

    setUrl(currentUrl);
    const matchedNav = Navigations.find((nav) => nav.href === pathName);
    setTitle(`${matchedNav?.name || ""}`);
  }, [location]);

  const isHymnsPage =
    location.pathname.toLowerCase().includes("/chants-desperanc") ||
    location.pathname.toLowerCase().includes("/chants-desperance");

  const coverImage = isHymnsPage ? HYMNS_COVER_IMAGE : DEFAULT_COVER_IMAGE;

  return (
    <Helmet>
      {title ? <title>Egarizim.com - {title}</title> : null}
      <link rel="canonical" href={url} />
      <meta property="og:image" content={coverImage} />
      <meta name="twitter:image" content={coverImage} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default AppSeoProvider;

